import FieldTypeReferenceDto from "../FieldTypeReferenceDto";
import FilterParameterDto from "../datasourcemodule/FilterParameterDto";
import DataTableFieldParameterDefinitionDto from "../datasourcemodule/DataTableFieldParameterDefinitionDto";

class AIFieldMappingDto {
    SourceFieldReferenceId: number;
    TransformationType: number | null;
    TransformationParameters: string | null;
    Name: string;
    Type: FieldTypeReferenceDto;
    DisplayName: string;
    Description: string;
    Filters: FilterParameterDto[];
    DeclaredVariables: DataTableFieldParameterDefinitionDto[];

    constructor(
        sourceFieldReferenceId: number,
        transformationType: number | null,
        transformationParameters: string | null,
        name: string,
        type: FieldTypeReferenceDto,
        displayName: string,
        description: string,
        filters: FilterParameterDto[],
        declaredVariables: DataTableFieldParameterDefinitionDto[] = []
    ) {
        this.SourceFieldReferenceId = sourceFieldReferenceId;
        this.TransformationType = transformationType;
        this.TransformationParameters = transformationParameters;
        this.Name = name;
        this.Type = type;
        this.DisplayName = displayName;
        this.Description = description;
        this.Filters = filters;
        this.DeclaredVariables = declaredVariables;
    }
}

export default AIFieldMappingDto;
